export const bills = {
	"07023/2022-23": {
		enrollment: 12020009001101,
		total: 70000,
		date: "2022-07-08 21:17:39.0",
	},
	"00646/2022-23": {
		enrollment: 12020009001101,
		total: 1000,
		date: "2022-04-08 23:10:33.0",
	},
	"15114/2021-22": {
		enrollment: 12020009001101,
		total: 70000,
		date: "2022-01-08 20:57:16.0",
	},
	"15124/2021-22": {
		enrollment: 12020009001102,
		total: 70000,
		date: "2022-01-08 20:57:16.0",
	},
	"15134/2021-22": {
		enrollment: 12020009001100,
		total: 1000,
		date: "2022-01-08 20:57:16.0",
	},
}
